<template>
  <div :class="'resultView '+ (type == 'view'?'flex':'')">
    <div class="detail">
      <template v-if="type == 'view'">
        <Collapse :value="['log', '1']">
          <Panel name="log">
            回访记录
            <template #content>
              <Table :columns="columnsCalled" :data="calledRecords" border size="small"></Table>
            </template>
          </Panel>
          <Panel name="1">
            回访结果
            <template #content>
              <table class="resultTable">
                <tr>
                  <td class="label">回访批次</td>
                  <td>{{recordItem.batchNumber}}</td>
                  <td class="label">分配时间</td>
                  <td>{{recordItem.allocateTime}}</td>
                </tr>
                <tr>
                  <td class="label">回访时间</td>
                  <td>{{recordItem.followUpTime}}</td>
                  <td class="label">是否超期</td>
                  <td>{{recordItem.overdue?'是':'否'}}</td>
                </tr>
                <tr>
                  <td class="label">回访要求</td>
                  <td colspan="3">{{recordData.requirements}}</td>
                </tr>

                <tr>
                  <td class="label">回访人员</td>
                  <td>{{recordItem.userName}}</td>
                  <td class="label">回访后满意度</td>
                  <td>{{satisfactionResultOptions.filter(item => item.value == recordItem.satisfactionResult)[0]?.label}}</td>
                </tr>

                <tr
                  v-if="recordItem.satisfactionResult && recordItem.satisfactionResult != recordItem.orgSatisfactionResult"
                >
                  <td class="label">
                    修正原因
                    <span style="color: red">*</span>
                  </td>
                  <td :colspan="recordItem.modifyReason == '99'?1:3">
                    <dicLabel :value="recordItem.modifyReason" category="modify_reason"></dicLabel>
                  </td>

                  <template v-if="recordItem.modifyReason == '99'">
                    <td class="label">
                      修正原因备注
                      <span style="color: red">*</span>
                    </td>
                    <td colspan="3">{{recordItem.modifyRemark}}</td>
                  </template>
                </tr>

                <!-- basically_satisfied("3","一般"),
    dissatisfied("4","不满意"),
    verydissatisfied("5","非常不满意");
                -->
                <tr
                  v-if="['basically_satisfied', 'dissatisfied', 'verydissatisfied'].indexOf(gaugingResult.satisfactionResult) >= 0"
                >
                  <td class="label">
                    不满意原因
                    <span style="color: red">*</span>
                  </td>
                  <td :colspan="recordItem.disSatisfactionReason == '99'?1:3">
                    <dicLabel
                      :value="recordItem.disSatisfactionReason"
                      category="dis_satisfaction_reason"
                    ></dicLabel>
                  </td>

                  <template v-if="recordItem.disSatisfactionReason == '99'">
                    <td class="label">
                      不满意原因备注
                      <span style="color: red">*</span>
                    </td>
                    <td colspan="3">{{recordItem.disSatisfactionRemark}}</td>
                  </template>
                </tr>
                <tr>
                  <td class="label">回访记录</td>
                  <td colspan="3">{{recordItem.remark}}</td>
                </tr>
                <tr v-if="fileUrl">
                  <td class="label">回访录音</td>
                  <td colspan="3">
                    <audio
                      :controlslist="showControlslist"
                      controls
                      ref="audio"
                      style=" min-width: 100%;"
                      width="100%"
                    >
                      <source :src="fileUrl" />
                    </audio>
                  </td>
                </tr>
                <tr>
                  <td class="label">附件</td>
                  <td colspan="3">
                    <template v-if="fileList && fileList.length>0">
                      <div :key="item.uid" class="sunflower-upload-list" v-for="item in fileList">
                        <!-- <img :src="item.url" v-if="item.getFileType=='image'" /> -->
                        <div :class="`fileIcon ${item.getFileType}Icon`" />
                        <div class="sunflower-upload-list-cover">
                          <Icon @click.native="viewFile(item)" type="md-eye"></Icon>
                        </div>
                      </div>
                    </template>
                  </td>
                </tr>
              </table>
            </template>
          </Panel>
        </Collapse>
      </template>
      <template v-else>
        <Tabs>
          <Tab-pane label="回访数据" name="data">
            <Form
              :label-width="0"
              :model="gaugingResult"
              :rules="gaugingResultValidate"
              ref="gaugingResult"
            >
              <table class="resultTable">
                <tr>
                  <td class="label">回访要求</td>
                  <td colspan="3">{{recordData.requirements}}</td>
                </tr>
                <tr>
                  <td class="label">回访前满意度</td>
                  <td>{{recordItem.orgSatisfactionResultLabel || '--'}}</td>
                  <td class="label">
                    回访后满意度
                    <span style="color: red">*</span>
                  </td>
                  <td>
                    <FormItem prop="satisfactionResult">
                      <Select filterable transfer v-model="gaugingResult.satisfactionResult">
                        <template v-for="item in satisfactionResultOptions">
                          <Option
                            :key="item.value+'-satisfactionResult'"
                            :value="item.value"
                            v-if="(item.supportICTypes || []).indexOf(recordItem.icType) >=0 && item.value != 'defaultsatisfied'"
                          >{{ item.label }}</Option>
                        </template>
                      </Select>
                    </FormItem>
                  </td>
                </tr>

                <tr
                  v-if="gaugingResult.satisfactionResult && gaugingResult.satisfactionResult != gaugingResult.orgSatisfactionResult"
                >
                  <td class="label">
                    修正原因
                    <span style="color: red">*</span>
                  </td>
                  <td :colspan="gaugingResult.modifyReason == '99'?1:3">
                    <FormItem prop="modifyReason">
                      <labelValue
                        :category="'modify_reason'"
                        :data="gaugingResult.modifyReason"
                        @change="(val) => {gaugingResult.modifyReason = val}"
                        transfer
                      ></labelValue>
                    </FormItem>
                  </td>

                  <template v-if="gaugingResult.modifyReason == '99'">
                    <td class="label">
                      修正原因备注
                      <span style="color: red">*</span>
                    </td>
                    <td colspan="3">
                      <FormItem prop="modifyRemark">
                        <Input
                          :autosize="{ minRows: 2, maxRows: 8 }"
                          maxlength="255"
                          show-word-limit
                          type="textarea"
                          v-model.trim="gaugingResult.modifyRemark"
                        ></Input>
                      </FormItem>
                    </td>
                  </template>
                </tr>

                <!-- basically_satisfied("3","一般"),
    dissatisfied("4","不满意"),
    verydissatisfied("5","非常不满意");
                -->
                <tr
                  v-if="['basically_satisfied', 'dissatisfied', 'verydissatisfied'].indexOf(gaugingResult.satisfactionResult) >= 0"
                >
                  <td class="label">
                    不满意原因
                    <span style="color: red">*</span>
                  </td>
                  <td :colspan="gaugingResult.disSatisfactionReason == '99'?1:3">
                    <FormItem prop="disSatisfactionReason">
                      <labelValue
                        :category="'dis_satisfaction_reason'"
                        :data="gaugingResult.disSatisfactionReason"
                        @change="(val) => {gaugingResult.disSatisfactionReason = val}"
                        transfer
                      ></labelValue>
                    </FormItem>
                  </td>

                  <template v-if="gaugingResult.disSatisfactionReason == '99'">
                    <td class="label">
                      不满意原因备注
                      <span style="color: red">*</span>
                    </td>
                    <td colspan="3">
                      <FormItem prop="disSatisfactionRemark">
                        <Input
                          :autosize="{ minRows: 2, maxRows: 8 }"
                          maxlength="255"
                          show-word-limit
                          type="textarea"
                          v-model.trim="gaugingResult.disSatisfactionRemark"
                        ></Input>
                      </FormItem>
                    </td>
                  </template>
                </tr>

                <tr>
                  <td class="label">
                    回访记录
                    <span style="color: red">*</span>
                  </td>
                  <td colspan="3">
                    <FormItem prop="remark">
                      <Input
                        :autosize="{ minRows: 2, maxRows: 8 }"
                        maxlength="1000"
                        show-word-limit
                        type="textarea"
                        v-model.trim="gaugingResult.remark"
                      ></Input>
                    </FormItem>
                  </td>
                </tr>
                <tr>
                  <td class="label">附件</td>
                  <td colspan="3">
                    <div class="flex">
                      <template v-if="fileList && fileList.length>0">
                        <div
                          :key="item.uid"
                          class="sunflower-upload-list"
                          style="max-width: 60px"
                          v-for="item in fileList"
                        >
                          <img :src="item.url" v-if="item.getFileType=='image'" />
                          <div :class="`fileIcon ${item.getFileType}Icon`" v-else />
                          <div class="sunflower-upload-list-cover">
                            <Icon @click.native="viewFile(item)" type="md-eye"></Icon>
                            <Icon @click.native="handleRemove(item)" type="md-trash"></Icon>
                          </div>
                        </div>
                      </template>
                      <div class="sunflower-upload-list" style="max-width: 60px">
                        <sunflowerFileUpload
                          :opts="fileOpts"
                          @uploadFile="uploadFile"
                          ref="uploadFile"
                        >
                          <template slot="uploadContent">
                            <div
                              class="pointer"
                              style="width: 58px;height:58px;line-height: 58px;text-align: center;"
                            >
                              <Icon size="20" type="ios-add"></Icon>
                            </div>
                          </template>
                        </sunflowerFileUpload>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </Form>
            <div style="display: flex;justify-content: center;align-items: center;padding: 8px;">
              <Button @click="submitResult('staging')" style="width: 200px; " type="primary">暂存</Button>

              <Dropdown @on-click="submitResult" style="margin-left: 20px">
                <Button style="width: 200px; " type="warning">
                  关闭回访
                  <Icon type="ios-arrow-down"></Icon>
                </Button>
                <DropdownMenu slot="list">
                  <DropdownItem name="final">
                    <div style="color: #19be6b">回访成功</div>
                  </DropdownItem>
                  <DropdownItem name="fail">
                    <div style="color: #ed4014">回访失败</div>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <!-- 
              <Button
                @click="submitResult('error')"
                style="width: 200px;margin-top: 10px"
                type="error"
              >回访失败关闭</Button>
              <Button
                @click="submitResult('final')"
                style="width: 200px;margin-top: 10px"
                type="warning"
              >保存</Button>-->
            </div>
          </Tab-pane>
          <Tab-pane label="回访记录" name="calledRecord">
            <Table :columns="columnsCalled" :data="calledRecords" border size="small"></Table>
          </Tab-pane>
        </Tabs>
      </template>
    </div>
    <div class="infos">
      <div class="consultContent">
        <chart-detail
          :group="recordData.consultationInfo"
          :showMask="false"
          ref="chartDetail"
          v-if="recordData.icType == 'IM'"
        ></chart-detail>
        <HLSimpleDetail
          :consultationInfo="recordData.consultationInfo"
          v-if="recordData.icType == 'HL'"
        ></HLSimpleDetail>
        <mcDetail :mc="recordData.consultationInfo" v-if="recordData.icType == 'MC'"></mcDetail>
      </div>
    </div>
    <water-mark :opacity="0.3"></water-mark>
    <Modal
      :title="'预览--'+ viewFileData.name"
      @on-cancel="()=>{this.showPreview= false}"
      fullscreen
      v-model="showPreview"
    >
      <filePreview :fileOption="viewFileData" v-if="showPreview"></filePreview>
    </Modal>
  </div>
</template>
<script> 
import HLSimpleDetail from '../ICHL/HLSimpleDetail.vue'
import chartDetail from '../ICIM/chartDetail.vue'
import mcDetail from '../ICMC/mcDetail.vue'
export default {
  name: 'followUpResult',
  components: {
    chartDetail,
    HLSimpleDetail,
    mcDetail
  },
  props: {
    itemId: {
      required: true
    }
  },
  data () {
    return {
      fileUrl: '',
      recordData: {},
      recordItem: {},
      calledRecords: [],
      gaugingResult: {
        itemId: null,
        result: null,
        remark: '',
        satisfactionResult: null,
        disSatisfactionReason: null,
        disSatisfactionRemark: null,
        modifyReason: null,
        modifyRemark: null,
      },
      gaugingResultValidate: {
        remark: [{ required: true, message: '请输入回访记录', trigger: "blur" }],
        disSatisfactionRemark: [{ required: true, message: '请输入不满意原因', trigger: "blur" }],
        modifyRemark: [{ required: true, message: '请输入修正原因', trigger: "blur" }],
        satisfactionResult: [{ required: true, message: '请选择回访后满意度', trigger: 'change' }],
        disSatisfactionReason: [{ required: true, message: '请选择不满意原因', trigger: 'change' }],
        modifyReason: [{ required: true, message: '请选择修正原因', trigger: 'change' }],
      },
      satisfactionResultOptions: [],
      fileList: [],
      fileOpts: {
        multiple: true,
        format: ['jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf', 'xls', 'xlsx'],
        showUploadList: false,
        defauleFiles: [],
        data: {
          catalogName: "FollowUp"
        },
      },
      showPreview: false,
      viewFileData: {},
      columnsCalled: [
        { title: "序号", align: "center", type: "index", minWidth: 90, },
        { title: "拨打时间", align: "right", key: "callTime", tooltip: true, minWidth: 160, },
        { title: "接通时间", align: "right", key: "establishedTime", tooltip: true, minWidth: 160, },
        { title: "结束时间", align: "right", key: "releaseTime", tooltip: true, minWidth: 160, }
      ]
    }
  },
  computed: {
    type: function () {
      if (this.recordItem.status == 'todo' || this.recordItem.status == 'during') {
        return 'gauging'
      }
      return 'view'
    },
    isAdmin: function () {
      return this.$store.getters['userInfo/isAdmin'] || false
    },
    systemRoles: function () {
      return (this.$store.getters['userInfo/user'] || {}).systemRoles || []
    },
    hasOperationRole: function () {
      return (this.systemRoles || []).indexOf('OPERATION_MANAGER') >= 0 || (this.systemRoles || []).indexOf('OPERATION') >= 0
    },
    showControlslist: function () {
      return (this.hasOperationRole || this.isAdmin) ? 'nofullscreen' : 'nodownload'
    }
  },
  watch: {
    itemId: {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (val) {
          this.getGauging()
        }
      }
    }
  },
  methods: {
    getBasePath: async function (fileId) {
      console.log('this.fileId', fileId)
      if (fileId) {
        let params = new this.$URLSearchParams()
        params.append("id", fileId)
        let data = await this.$axios.post(this.$apis.fileServerApi.getFileVisitedPath, params)
        this.fileUrl = data.result
      }

      // return data.result
    },

    uploadFile: function (data) {
      let that = this
      this.fileList = data
      if (this.fileList.length > 0) {
        this.fileList.forEach(function (obj) {
          obj['getFileType'] = that.$common.getFileType(obj.fileType)
        })
      }
    },
    handleRemove: function (file) {
      const infileList = this.$refs.uploadFile.fileList
      this.$refs.uploadFile.fileList.splice(infileList.indexOf(file), 1)
    },
    viewFile (item, index) {
      this.viewFileData = Object.assign({}, item)
      this.viewFileData.filePath = item.url
      this.showPreview = true
    },
    submitResult: function (type) {
      let that = this
      this.gaugingResult.type = type
      switch (type) {
        case 'staging':
          this.$Modal.confirm({
            title: '提醒',
            content: `<p>请确认是否${type == 'final' ? '提交' : '暂存'}本次回访内容！</p>`,
            okText: type == 'final' ? '提交' : '暂存',
            onOk: () => {
              that.$Spin.show({
                render: (h) => {
                  return h('div', [
                    h('Icon', {
                      'class': 'demo-spin-icon-load',
                      props: {
                        type: 'ios-loading',
                        size: 18
                      }
                    }),
                    h('div', '正在提交，请稍候...')
                  ])
                }
              })
              this.gaugingResult.itemId = this.itemId
              that.$set(that.gaugingResult, 'files', that.fileList)
              that.$axios.post(this.$apis.followUpApi.gauging.gaugingResult, this.gaugingResult).then(res => {
                if (res.success) {
                  this.recordItem = res.result || {}
                  if (this.recordItem.fileId) {
                    this.getBasePath(this.recordItem.fileId)
                  }
                  that.$Message.success({
                    duration: 3,
                    content: '暂存成功'
                  })
                } else {
                  that.$Message.error({
                    duration: 3,
                    content: res.message
                  })
                }
              }).catch(function (err) {
                console.error("submitResult errpr", err)
                that.$Message.error('提交失败！')
              }).finally(() => {
                that.$Spin.hide()
              })
            }
          })
          break
        case 'fail':
          if (this.gaugingResult.remark == null || this.gaugingResult.remark == undefined || this.gaugingResult.remark.trim() == '') {
            this.$Message.warning({
              content: '请填写回访记录',
              duration: 3
            })
            return
          }
          this.$Modal.confirm({
            title: '提醒',
            content: `<p>请确认是否回访失败，关闭本次回访！</p>`,
            okText: '关闭',
            onOk: () => {
              that.$Spin.show({
                render: (h) => {
                  return h('div', [
                    h('Icon', {
                      'class': 'demo-spin-icon-load',
                      props: {
                        type: 'ios-loading',
                        size: 18
                      }
                    }),
                    h('div', '正在提交，请稍候...')
                  ])
                }
              })
              this.gaugingResult.itemId = this.itemId
              that.$set(that.gaugingResult, 'files', that.fileList)
              that.$axios.post(this.$apis.followUpApi.gauging.gaugingResult, this.gaugingResult).then(res => {
                if (res.success) {
                  this.recordItem = res.result || {}
                  if (this.recordItem.fileId) {
                    this.getBasePath(this.recordItem.fileId)
                  }
                  that.$Message.success({
                    duration: 3,
                    content: '回访完成'
                  })
                } else {
                  that.$Message.error({
                    duration: 3,
                    content: res.message
                  })
                }
              }).catch(function (err) {
                console.error("submitResult errpr", err)
                that.$Message.error('提交失败！')
              }).finally(() => {
                that.$Spin.hide()
              })
            }
          })
          break
        case 'final':
          this.$refs["gaugingResult"].validate(valid => {
            if (valid) {
              this.$Modal.confirm({
                title: '提醒',
                content: `<p>请确认是否${type == 'final' ? '提交' : '暂存'}本次回访内容！</p>`,
                okText: type == 'final' ? '提交' : '暂存',
                onOk: () => {
                  that.$Spin.show({
                    render: (h) => {
                      return h('div', [
                        h('Icon', {
                          'class': 'demo-spin-icon-load',
                          props: {
                            type: 'ios-loading',
                            size: 18
                          }
                        }),
                        h('div', '正在提交，请稍候...')
                      ])
                    }
                  })
                  this.gaugingResult.itemId = this.itemId
                  that.$set(that.gaugingResult, 'files', that.fileList)
                  that.$axios.post(this.$apis.followUpApi.gauging.gaugingResult, this.gaugingResult).then(res => {
                    if (res.success) {
                      this.recordItem = res.result || {}
                      if (this.recordItem.fileId) {
                        this.getBasePath(this.recordItem.fileId)
                      }
                      that.$Message.success({
                        duration: 3,
                        content: '回访完成'
                      })
                    } else {
                      that.$Message.error({
                        duration: 3,
                        content: res.message
                      })
                    }
                  }).catch(function (err) {
                    console.error("submitResult errpr", err)
                    that.$Message.error('提交失败！')
                  }).finally(() => {
                    that.$Spin.hide()
                  })
                }
              })
            }
          })
          break
      }

    },
    getGauging: function () {
      let that = this
      let param = new this.$URLSearchParams()
      param.append('itemId', this.itemId)
      that.$axios.post(this.$apis.followUpApi.gauging.getGauging, param).then(res => {
        if (res.success) {
          this.recordData = res.result || {}
          this.calledRecords = (res.result || {}).calledRecords || []
          this.recordItem = this.recordData.recordItem || {}
          this.gaugingResult.remark = this.recordItem.remark
          this.gaugingResult.satisfactionResult = this.recordItem.satisfactionResult
          if (this.recordItem.fileId) {
            this.getBasePath(this.recordItem.fileId)
          }
          this.fileList = []
          if (this.recordItem.files.length > 0) {
            this.recordItem.files.forEach(item => {
              item['getFileType'] = this.$common.getFileType(item.fileType)
              this.fileList.push(item)
            })
          }
        } else {
          that.$Message.error({
            duration: 3,
            content: res.message
          })
        }
      }).catch(function (err) {
        console.error("getGauging errpr", err)
        that.$Message.error('获取回访记录失败！')
      })
    },
    loadSatisfactionResults: async function () {
      this.satisfactionResultOptions = await this.$baseData.handleData(false, this.$apis.common.satisfactionResultOptions, null) || []
    },
  },
  beforeMount () {
    this.loadSatisfactionResults()
  }
}
</script>
<style lang="less" scoped>
.resultView {
  height: 100%;
  // position: relative;
  box-sizing: border-box;
  overflow-y: auto;

  .consultContent {
    // margin-right: 1rem;
    width: 100%;
    max-width: 100%;

    .selfPanel {
      border-radius: 4px;
      border: 1px solid #d7d7d7;
    }
  }

  .infos {
    display: flex;
    padding: 1rem;
    overflow-y: auto;
  }

  .detail {
    // background: #fff;
    padding: 1rem;
    overflow-y: auto;
    // box-shadow: 5px 4px 5px #ddd;
    // border-bottom: 1px dashed #ddd;
    // margin-bottom: 5px;
  }
}

.resultView.flex {
  overflow-y: hidden;
  display: flex;

  .infos,
  .detail {
    padding: 0;
    margin: 10px;
  }

  .consultContent {
    margin-right: 0;
  }
}

.resultView:not(.flex) {
  .detail {
    position: sticky;
    top: 0;
    z-index: 999;
    background: #fff;
    padding: 1rem;
    overflow-y: auto;
    // box-shadow: 5px 4px 5px #ddd;
    // border-bottom: 1px dashed #ddd;
    // margin-bottom: 5px;
  }
}

.sunflower-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  /* border: 1px solid transparent; */
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.sunflower-upload-list img {
  width: 100%;
  height: 100%;
}
.sunflower-upload-list .fileIcon {
  width: 100%;
  height: 100%;
}
.sunflower-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.sunflower-upload-list:hover .sunflower-upload-list-cover {
  display: block;
}
.sunflower-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.resultTable {
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;

  .conclusion {
    background: #eee;
    text-align: center;
    font-weight: 600;
    font-size: 0.9rem;
  }

  td {
    border: 1px solid #dcdee2;
    padding: 2px 4px;
    min-height: 2.4rem;
    height: 2.4rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  td.label {
    text-align: center;
    font-size: 0.85rem;
    background: #f8f8f9;
    width: 20%;
  }

  .ivu-form-item {
    margin-bottom: 0 !important;
  }
}
</style>